import { getDomainOrigin } from 'utils/serverConfig';

const API_ENDPOINTS = {
    gst: {
        fetchGSTDetails: (partnerId: string) =>
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/gst-details/fetch`,
        submitGSTDetails: (partnerId: string) =>
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/gst-details/submit`,
        validateGSTDetails: (partnerId: string, async: boolean) =>
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/gst-details/validate?async=${async.valueOf()}`,
        //  getUser: (id) => `${BASE_URL}/users/${id}`,
    },
};

export default API_ENDPOINTS;
